import React, { useState } from 'react';
import axios from 'axios';
import '../styles/Coming-soon.css';
import linesgridimg from '../assest/lines grid.png';
import cubeimg from '../assest/cubes.png';

const ComingSoon = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [showPopup, setShowPopup] = useState(false); 

  const handleSubmit = async () => {
    if (!email) return setStatus('Please enter a valid email');
    try {
      //await axios.post('http://localhost:8004/api/coming-soon', { email }); // Uncomment this line for local testing
      await axios.post('https://cz-engine.onrender.com/api/coming-soon', { email });
      setStatus('');
      setEmail('');
      setShowPopup(true); 
      // setTimeout(() => setShowPopup(false), 4000); 
    } catch (error) {
      console.error("Error sending email:", error);
      setStatus('Something went wrong. Try again later.');
    }
  };

  return (
    <div className="coming-soon-container">
      <img src={linesgridimg} alt="grid" className="bg-grid" />
      <div className="content-wrapper">
        <h1>PROTOTYPE UNDER <br /> DEVELOPMENT</h1>
        <p>We’re excited to offer early access.</p>
        <div className="form-group">
          <input
            type="email"
            placeholder="Please enter your e-mail address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button onClick={handleSubmit}>Schedule Demo</button>
        </div>
        {status && <p className="status-msg">{status}</p>}


        {showPopup && (
          <div className="popup">
            <div className="popup-content">
              <h2>Thank You!</h2>
                  <p>Thank you so much for contacting <strong>CauZen</strong>. Our team has received your request and we will get back to you within 24 hours.</p>
              
          <div className='popup-container'>
                    <button onClick={() => setShowPopup(false)} className="close-button">Close</button>
                  </div>
            </div>
          </div>
        )}

        <div className="ribbons">
          <div className="ribbon red">
            COMING SOON | COMING SOON | COMING SOON |  COMING SOON | COMING SOON | COMING SOON |  COMING SOON | COMING SOON | COMING SOON |  COMING SOON | COMING SOON | COMING SOON |
          </div>
          <div className="ribbon green">
            COMING SOON | COMING SOON | COMING SOON |  COMING SOON | COMING SOON | COMING SOON |  COMING SOON | COMING SOON | COMING SOON |  COMING SOON | COMING SOON | COMING SOON |
          </div>
        </div>
      </div>
      <img src={cubeimg} alt="Cube Left" className="cube cube-left" />
      <img src={cubeimg} alt="Cube Right" className="cube cube-right" />
    </div>
  );
};

export default ComingSoon;
